<template>
  <v-card class="pa-5"   :style="{ border: '1px solid var(--primary-boarder-color)' }">
    <v-row class="pa-5 pb-0 d-flex justify-space-between align-center">
      <span class="text-h6 font-weight-medium">My Details</span>
      <div v-if="ProfileDetails">
        <v-btn v-if="!editMode" @click="toggleEditMode" fab small depressed color="#00B3FF" class="mr-2 white--text" sole>
          <v-icon >mode_edit</v-icon>
        </v-btn>
        <v-btn v-if="editMode" @click="saveChanges" fab small depressed color="blue" class="mr-2 white--text" sole>
          <v-icon>mdi-check</v-icon>
        </v-btn>
        <v-btn v-if="editMode" @click="cancelChanges" fab small depressed color="gray" class="mr-2 white--text" sole>
          <v-icon >mdi-close</v-icon>
        </v-btn>
      </div>
    </v-row>
    <v-row v-if="ProfileDetails">
      <v-col>
        <v-list>
          <ProfileDetailItem
            :icon="'double_arrow'"
            :label="'Full Name'"
            :value="ProfileDetails.name"
            :edit-mode="editMode"
            @input="updateProfileDetail('name', $event)"
          ></ProfileDetailItem>
          <v-divider class="border-opacity-25"></v-divider>
          <ProfileDetailItem
            :icon="'double_arrow'"
            :label="'Email'"
            :value="ProfileDetails.email"
            
            @input="updateProfileDetail('email', $event)"
          ></ProfileDetailItem>
          <v-divider class="border-opacity-25"></v-divider>
          <ProfileDetailItem
            :icon="'double_arrow'"
            :label="'Mobile'"
            :value="ProfileDetails.mobile"
            :edit-mode="editMode"
            @input="updateProfileDetail('mobile', $event)"
          ></ProfileDetailItem>
          <v-divider class="border-opacity-25"></v-divider>
          <ProfileDetailItem
            :icon="'double_arrow'"
            :label="'Address 1'"
            :value="ProfileDetails.employer.address1"
            :edit-mode="editMode"
            @input="updateProfileDetail('employer.address1', $event)"
          ></ProfileDetailItem>
          <v-divider class="border-opacity-25"></v-divider>
          <ProfileDetailItem
            :icon="'double_arrow'"
            :label="'Address 2'"
            :value="ProfileDetails.employer.address2"
            :edit-mode="editMode"
            @input="updateProfileDetail('employer.address2', $event)"
          ></ProfileDetailItem>
          <v-divider class="border-opacity-25"></v-divider>
          <ProfileDetailItem
            :icon="'double_arrow'"
            :label="'City'"
            :value="ProfileDetails.employer.city"
            :edit-mode="editMode"
            @input="updateProfileDetail('employer.city', $event)"
          ></ProfileDetailItem>
          <v-divider class="border-opacity-25"></v-divider>
          <ProfileDetailItem
            :icon="'double_arrow'"
            :label="'State'"
            :value="ProfileDetails.employer.state"
            :edit-mode="editMode"
            @input="updateProfileDetail('employer.state', $event)"
          ></ProfileDetailItem>
        </v-list>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import ProfileDetailItem from "@/components/profile/ProfileDetailItem.vue";

export default {
  components: {
    ProfileDetailItem,
  },
  props: {
    ProfileDetails: Object,
  },
  data() {
    return {
      editMode: false,
      tempProfileDetails: null,
    };
  },
  methods: {
    toggleEditMode() {
      this.editMode = !this.editMode;
      if (this.editMode) {
        this.tempProfileDetails = { ...this.ProfileDetails };
      }
    },
    saveChanges() {
      const formData = new FormData();
      formData.append('full_name', this.ProfileDetails['name']);
      formData.append('email', this.ProfileDetails['email']);
      formData.append('mobile', this.ProfileDetails['mobile'] || "");
      formData.append('address1', this.ProfileDetails['employer.address1'] || this.ProfileDetails.employer.address1 || "");
      formData.append('address2', this.ProfileDetails['employer.address2'] || this.ProfileDetails.employer.address2 || "");
      formData.append('city', this.ProfileDetails['employer.city'] || this.ProfileDetails.employer.city || "");
      formData.append('state', this.ProfileDetails['employer.state'] || this.ProfileDetails.employer.state || "");
    
    this.$emit("update-employer", formData);
          this.editMode = false;
    },
    cancelChanges() {
      this.ProfileDetails = { ...this.tempProfileDetails };
      this.editMode = false;
    },
    updateProfileDetail(key, value) {
      this.$set(this.ProfileDetails, key, value);
    },
   },
};
</script>

<style scoped>
.icon-box {
  border-radius: 30%;
}

.detail-label {
  font-weight: 500;
  color: black;
  padding-top: 20px;
}

.detail-value {
  color: #555;
  font-weight: 400;
}
</style>
